export enum OAuthFlowTypeEnum {
	Basic = 'basic',
	Service = 'service',
	Integration = 'integration',
	Link = 'link',
}
